import { VariantProps, cva } from 'class-variance-authority'
import { CSSProperties, FC } from 'react'
import { getFileUrl } from '~/helpers/fileUploadHelpers'
import { OrganizationBranding } from '~/stores/stores.types'

const getAvatarBackground = (branding?: OrganizationBranding | null) => {
  if (!branding) return {}
  return {
    background: `linear-gradient(-45deg, ${branding.primaryColor}, ${
      branding.secondaryColor || branding.primaryColor
    })`,
  }
}

export const OrganizationAvatar: FC<AvatarProps> = ({
  size,
  rounded,
  className,
  branding,
  style,
  name,
  iconFileId,
}) => {
  const letters = name.split(' ').map((p) => p[0])
  return iconFileId ? (
    <img
      className={avatarVariants({ size, rounded, className })}
      src={getFileUrl(iconFileId, { redirect: 'true' })}
      alt={name}
    />
  ) : (
    <div
      className={avatarVariants({
        size,
        rounded,
        className: className,
      })}
      style={{ ...style, ...getAvatarBackground(branding) }}
    >
      <span className="grow">
        {letters[0]}
        {letters[1]}
      </span>
    </div>
  )
}

interface AvatarProps extends VariantProps<typeof avatarVariants> {
  name: string
  branding?: OrganizationBranding | null
  className?: string
  style?: CSSProperties
  iconFileId?: string | null
}

const avatarVariants = cva(
  'user-select-none aspect-square text-white bg-grey-300 shrink-0 grow-0 font-bold text-center inline-flex items-center justify-items-center',
  {
    variants: {
      size: {
        sm: 'w-[20px] text-[9px]',
        md: 'w-[28px] text-[11px]',
        lg: 'w-[50px] text-[20px]',
      },
      rounded: {
        full: 'rounded-full',
        md: 'rounded-md',
        sm: 'rounded-md',
      },
    },
    defaultVariants: {
      size: 'md',
      rounded: 'full',
    },
  },
)
